




































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import CardDesignPreview from '@/components/apps/CardDesignPreview.vue';
import Apps from '@/store/modules/Apps';
import TemplateSubscribeButton from '@/components/apps/TemplateSubscribeButton.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Users from '@/store/modules/Users';
import MarketPlaceCard from '@/components/apps/MarketPlaceCard.vue'
import LoginRegisterDialog from '@/views/Auth/LoginRegisterDialog.vue';
import { Auth } from 'aws-amplify';
import vuetify from '@/plugins/vuetify';


const workspaceOptionsModule = getModule(WorkspaceOptions);
const appModule = getModule(Apps);

@Component({
    name: 'MarketplaceHome',
    components: {
        CardTitle,
        CardDesignPreview,
        TemplateSubscribeButton,
        MarketPlaceCard,
        LoginRegisterDialog
    },
    directives: {},
})
export default class MarketplaceHome extends Vue {
    private show = false;

    @Prop({ default: '100%', type: String })
    width!: string;

    @Prop({ default: '100%', type: String })
    height!: string;

    @Prop({default: false, type: Boolean})
    isMarketplace

    @Prop()
    product: string

    private dialogShow = {};

    private noImageUrl='https://upload.wikimedia.org/wikipedia/commons/1/1d/No_image.JPG';

    get selectedAppId() {
        return appModule.selectedAppId;
    }

    get apps() {
        return appModule.marketplaceItems;
    }

    get commentBottomHeight() {
        return workspaceOptionsModule.commentBottomHeight;
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get currentUserId() {
        if (getModule(Users).currentUserProfile) {
            return getModule(Users).currentUserProfile.userId;
        } else {
            return undefined;
        }
    }

    get installedAppTemplates() {
        return this.appsTemplates.filter((app) => this.currentUserId && app.userIds && this.currentUserId in app.userIds);
    }

    get nonInstalledAppTemplates() {
        return this.appsTemplates.filter(
            (app) => !app.userIds || !this.currentUserId || !(this.currentUserId in app.userIds)
        );
    }

    get appsTemplates() {
        return appModule.appTemplates;
    }

    get decisionTemplates() {
        return appModule.decisionTemplates;
    }

    get installedDecisionTemplates() {
        return this.decisionTemplates.filter(
            (app) => app.userIds && this.currentUserId && this.currentUserId in app.userIds
        );
    }
    get nonInstalledDecisionTemplates() {
        return this.decisionTemplates.filter(
            (app) => !app.userIds || !this.currentUserId || !(this.currentUserId in app.userIds)
        );
    }

    get decisionTemplateDetailsDictionary() {
        return appModule.decisionTemplateDetailsDictionary;
    }

    get marketPlaceDictionary() {
        return appModule.marketPlaceDictionary
    }

    mounted() {
        appModule.fetchMarketplaceItems().then(result=> {
            let cookieProduct =  Vue.$cookies.isKey('app-subscribe') ? Vue.$cookies.get('app-subscribe') : null
            //If app id in cookie exists
            if(cookieProduct != undefined && this.marketPlaceDictionary[cookieProduct] != undefined ) {
                //Check if checkout session id in url and if the checkout session id is in a cookie and if they match
                if(this.$router?.currentRoute?.query?.session_id && Vue.$cookies.isKey('checkout-session') && this.$router?.currentRoute?.query?.session_id === Vue.$cookies.get('checkout-session') ) {
                    let app = this.marketPlaceDictionary[cookieProduct]
                    this.subscribeApp(app.id)
                }
                // Removed auto subscribing of free apps on login - CHRIS Sept 13
                //  else {
                //     if(!cookieProduct.stripeProductCode) {
                //         let app = this.marketPlaceDictionary[cookieProduct]
                //         this.subscribeApp(app.id)
                //     }
                // }
            }

            Vue.$cookies.remove('app-subscribe')
            Vue.$cookies.remove('checkout-session')
        })
       

    }

    private async subscribeApp(appId: string) {
        let authUser = await Auth.currentUserInfo();
        
        if(authUser != null) { 
              await appModule.addUserToApp({
                id: appId,
                userId: authUser.username
            });
        }
      

    }

    get cardContainerSize() {
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else {
            commentHeight = 0;
        }
        if(this.isMarketplace) {
            return `
                padding-top: 36px;
                max-width: 1416px;
                margin: 36px auto;
                padding: 12px;
                border-radius: 16px;
            `;
        }
        else
            return `max-height : calc(100vh - 120px - ${commentHeight}px); min-height:calc(100vh - 120px - ${commentHeight}px)`;
    }

    private openDetailDialog(item: any){
        Vue.set( this.dialogShow, item.id, true );
    }

    private closeDetailDialog(item: any){
        Vue.set( this.dialogShow, item.id, false );

    }
}
